import Vue from 'vue';

export default {
  spinnerForRequest: {
    onFulfilled (conf) {
      if (!conf.hideSpinner) Vue.$loading.show();
      return conf;
    },
    onRejected (error) {
      return Promise.reject(error);
    },
  },
  spinnerForResponse: {
    onFulfilled (response) {
      if (!response.config.hideSpinner) Vue.$loading.hide();
      return response;
    },
    onRejected (error) {
      if (error.response) {
        if (!error.response.config.hideSpinner) Vue.$loading.hide();
      }
      return Promise.reject(error);
    },
  },
  errorHandlerForResponse: {
    onFulfilled (response) {
      return response;
    },
    async onRejected (error) {
      const response = error.response;
      if (response) {
        const hideErrorMessage =
          Object.prototype.hasOwnProperty.call(
            response.config,
            'hideErrorMessage',
          ) && response.config.hideErrorMessage;
        if (
          !hideErrorMessage &&
          response.data['errors'] &&
          response.data.errors.length
        ) {
          response.data.errors.map((err) => Vue.$toast.error(err.message, {
            duration: 5000,
          }));
        } else if (!hideErrorMessage && response.data['error']) {
          if (response.data.error.message) {
            Vue.$toast.error(response.data.error.message, {
              duration: 5000,
            });
          } else {
            Vue.$toast.error(response.data.error, {
              duration: 5000,
            });
          }
        } else if (!hideErrorMessage) {
          Vue.$toast.error('Beklenmeyen bir hata oluştu.', {
            duration: 5000,
          });
        }
      }
      return Promise.reject(error);
    },
  },
};
